<template lang="pug">
md-toolbar(md-theme='brown-white')
  h2.md-title(style='flex: 1')
    | {{ section }}
  md-subheader
    span.account-name
      | {{ account_name }}
      small.impersonate(v-if='impersonate') IMPERSONATING
        button.btnStop(@click='stop') [ STOP ]
    span.breadcrumb-item(v-for='item in nav')
      span.breadcrumb-divider
        | /
      router-link(v-if='item.route', :to='{ name: item.route }')
        | {{ item.title }}
      span(v-else)
        | {{ item.title }}
    
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import accountService from '../services/accountService';

export default {
  props: {
    section: {
      type: String,
      required: true
    },
    nav: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      impersonate: false,
      impersonatedAccountName: ''
    };
  },
  computed: {
    account_name() {
      if(this.impersonate) {
        return this.impersonatedAccountName;
      } else {
        return this.$store.state.user.useraccount.name;
      }
    }
  },
  methods: {
    stop() {
      localStorage.removeItem('impersonate');
      location.href = '/';
    }
  },
  mounted() {

    if(localStorage.getItem('impersonate')) {

      this.impersonate = true;

        // get account name
        accountService.get(localStorage.getItem('impersonate'))
        .then((account_response) => {
          this.impersonatedAccountName = account_response.data.account.name;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
  .account-name {
    color: #fad962;
    font-size: 18px;
  }
  .breadcrumb-item {
    color: #fff;
    font-size: 15px;
  }
  .breadcrumb-divider {
    opacity: .5;
    padding: 0 5px;
  }
  .impersonate {
    display: block;
    font-size: 11px;
  }

  .btnStop{
    background-color: transparent;
    border: none;
    color: #ccc;
    font-size: 11px;
    transition: all 0.4s;
    &:hover{
      transform: scale(1.05);
      cursor: pointer;
      color: #fa1f1f;
    }
    
  }
</style>



// WEBPACK FOOTER //
// src/shared-components/Breadcrumbs.vue